import React from "react";

const Button = ({style, children, href, onClick, className}) => {
    const ButtonHtml = (props) => (props.href ? <a {...props}>{props.children}</a> : <button {...props}/>);
    return(
        <ButtonHtml href={href} onClick={onClick} className={className ? style ? `button is-style-btn-${style} ${className}` : className : `button is-style-btn-${style}`}>
            <span className="button-link">{children}</span>
        </ButtonHtml>
    )
};

export default Button;